angular.module('common').filter('questionGroupTypeToString', function() {
  return function(type) {
    return I18n.t('activerecord.choices.question_group.type.' + type);
  };
});
